import { EventAggregator } from 'aurelia-event-aggregator';
import { autoinject, bindable } from 'aurelia-framework';
import { GlobalContextService } from '../../components/global-select/global-context-service';
import { ApiService } from '../../utils/api-service';
import { ResourceService } from '../../utils/resourceService';
import { ReportService, IUntargetedFinancialEntryDataAM, IUntargetedFinancialEntryMunicipalityAllocationRuleAM } from './report-api';

@autoinject
export class UntargetedFinancialEntries {
	data: IUntargetedFinancialEntryDataAM[];
	scopeId: string;

	private scopeItemName = 'scope';

	constructor(
		private api: ReportService,
		private globalContext: GlobalContextService,
		private eventAggregator: EventAggregator,
		private resourceService: ResourceService) {
	}

	async attached() {
		const scope = this.globalContext.getItem(this.scopeItemName);

		if (scope != null) {
			this.scopeId = scope.id;
			this.data = await this.loadEntries(this.scopeId);
		}

		this.eventAggregator.subscribe(`idChanged-${this.scopeItemName}`, async id => {
			this.data = await this.loadEntries(id);
		});
	}

	async scopeIdChanged(newValue: string) {
		this.data = await this.loadEntries(newValue);
	}

	async loadEntries(scopeId: string) {
		return await this.api.getUntargetedFinancialEntriesForScope(scopeId);
	}

	formatRule(rule: IUntargetedFinancialEntryMunicipalityAllocationRuleAM) {
		return this.resourceService.getResource('MunicipalityAllocationRule_' + rule.allocationType)
			+ (rule.allocationArguments ? `: ${rule.allocationArguments}` : '');
	}
}